export { ConfigProvider, ConfigConsumer, useConfig } from './context';
export { withConfig, ConfigProps } from './withConfig';
